import { MotivoCancelamento } from "../motivo-cancelamento/motivo-cancelamento";

export class MotivoCancelamentoMarcacao {

  idUserCancelamento: number = 0;

  loginUserCancelamento: string = '';
  
  dataCancelamento: Date = new Date();
  
  motivoCancelamento: MotivoCancelamento = new MotivoCancelamento();

  obsMotivoCancelamento: string = '';
  
  dataCancelamentoFormatada: string = '';

}
